import { CSSProperties } from 'react';

export const formSectionHeaderStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  marginTop: 20,
  marginBottom: 12,
};

export const formSectionAccentBarStyle: CSSProperties = {
  width: 4,
  height: 18,
  borderRadius: 2,
  marginInlineEnd: 10,
};

export const formSectionDividerStyle: CSSProperties = {
  flex: 1,
  height: 1,
  backgroundColor: '#e2e8f0',
  marginLeft: 16,
};

export const formTabsRootStyle: CSSProperties = {
  marginTop: 4,
};

export const formTabPanelStyle: CSSProperties = {
  paddingTop: 4,
  paddingBottom: 8,
};
